module.exports = __webpack_public_path__ + "static/media/pmg_updates_icon.0960133b.svg";